import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import api from '../../services/api.service'

const BASE_PATH = '/lottustech/configuracoesBoletos'
const crud = build(validate, BASE_PATH)
const prefix = 'crudConfiguracaoBoleto'

const newTypes = {
  RESET: `${prefix}reset`,
  SET_BOOLEAN_FILTER: `${prefix}setBooleanFilter`,
  SET_LOADING_VALIDAR_TOKEN: `${prefix}setLoadingValidarToken`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.setBooleanFilter = (field, value) => {
  return {
    type: types.SET_BOOLEAN_FILTER,
    field,
    value,
  }
}

actions.setLoadingValidarToken = (loading) => {
  return {
    type: types.SET_LOADING_VALIDAR_TOKEN,
    payload: loading,
  }
}

actions.validarToken = (oid) => {
  return (dispatch) => {
    dispatch(actions.setLoadingValidarToken(true))
    return api
      .post(`${BASE_PATH}/validarToken/${oid}`)
      .then((response) => {
        dispatch(actions.setLoadingValidarToken(false))
        return response
      })
      .catch((error) => {
        dispatch(actions.setLoadingValidarToken(false))
        throw error
      })
  }
}

export { types, actions }
